import { render, staticRenderFns } from "./Concursos.vue?vue&type=template&id=0d9d7cdc&"
import script from "./Concursos.vue?vue&type=script&lang=js&"
export * from "./Concursos.vue?vue&type=script&lang=js&"
import style0 from "./Concursos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports